import React from 'react';
import PropTypes from 'prop-types';
import VerticalLabelList from '../../../../label/VerticalLabelList';
import FieldSet from '../../../../fieldset/FieldSet';

const NcDmvCrashReportsDetails = ({ selectedCrashReport, }) => {
  const billBreakdown = selectedCrashReport.externalBillId.split('-');

  return (
    <>
      <FieldSet title="Crash Report">
        <VerticalLabelList items={VerticalLabelList.toList({
          Id: selectedCrashReport.id,
          'Customer ID': selectedCrashReport.customerId,
          'Requester\'s Driver\'s License Number': selectedCrashReport.externalAccountId,
          'Searched Driver\'s License Number': billBreakdown[1],
          'Crash ID': billBreakdown[0],
          'Crash Date': billBreakdown.slice(2, 5).join('-'),
          'External Bill Id': selectedCrashReport.externalBillId,
          'Original Bill Balance': selectedCrashReport.originalBillBalance_value,
          'Client Reconciled Timestamp': selectedCrashReport.clientReconciledTimestamp,
        })}
        />
      </FieldSet>

      <FieldSet title="Transaction">
        <VerticalLabelList items={VerticalLabelList.toList({
          Id: selectedCrashReport.id,
          'Payment Transaction ID': selectedCrashReport.paymentTransactionId,
          'Payment Transaction Line Item ID': selectedCrashReport.paymentTransactionLineItemId,
          'Payment Amount': selectedCrashReport.paymentAmount,
          'Payment Date': selectedCrashReport.paymentDate,
        })}
        />
      </FieldSet>
    </>
  );
};

export default NcDmvCrashReportsDetails;

NcDmvCrashReportsDetails.propTypes = {
  selectedCrashReport: PropTypes.instanceOf(Object).isRequired,
};
